/*
 * @Author: your name
 * @Date: 2020-09-05 18:06:15
 * @LastEditTime: 2020-10-16 11:44:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \eunke-st-www\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import appuserRouter from './modules/appuserRouter'
import shoppingMallRouter from './modules/shoppingMallRouter'
import businessRouter from './modules/businessRouter'
import financeRouter from './modules/financeRouter'
import reportRouter from './modules/reportRouter'
import systemRouter from './modules/systemRouter'
/* Router Modules */
const Main = () => import('../views/Main.vue')


Vue.use(VueRouter)


// 普通路由
export const constantRoutes = [
	{
		path: '/',
		name: 'Main',
		component: Main,
		redirect: '/home',
		hidden: true,
		children: [{
			path: 'home',
			name: 'Home',
			component: () => import('../views/Home.vue'),
			meta: {
				title: '省钱运管理系统'
			}
		}],
	},
	{
		path: '/login',
		name: 'Login',
		hidden: true,
		component: () => import('../views/Login.vue'),
		meta: {
			title: '登录'
		}
	},
	{
		path: '/register',
		name: 'Register',
		hidden: true,
		component: () => import('../views/Register.vue'),
		meta: {
			title: '注册'
		}
	},
]
// const moduleRouter=require.context('./modules',true,/\.js$/);
// const allRouter=moduleRouter.keys().reduce((allRouter,routePath)=>{
// 	const value=moduleRouter(routePath);
// 	allRouter.push(value.default);
// 	return allRouter;
// },[])
// console.log(allRouter)
// 侧边栏路由
export const asyncRoutes = [
	businessRouter,
	appuserRouter,
	financeRouter,
	reportRouter,
	shoppingMallRouter,
	systemRouter,
	
	{ path: '*', redirect: '/home', hidden: true }
]
const createRouter = () => new VueRouter({
	mode: 'history',
	base: "pre-sqy",
  	routes: constantRoutes,
	
  })
  
const router = createRouter()

export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}


export default router
